import styled from "styled-components";


export const StyledHorLayoutGrid = styled.div`
    width: 100%;
    height : 33.3333%;
    position: absolute;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
`

export const StyledVerLayoutGrid = styled.div`
    width: 33.3333%;
    position: absolute;
    height: 100%;
    border-left: 1px solid white;
    border-right: 1px solid white;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
`